import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {
    convertCurrencyFormatPositiveNegative, convertPersianDateToUniversalDate, convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonPrimary, RaikoButtonSecondary, RaikoConfirmDialog,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoDatePicker,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoMoneyInputOutlined,
    RaikoSectionContainer,
    RaikoTableTitleContainer,
    showErrorMessage, showSuccessMessage,
    RaikoErrorSection, RaikoFlexFirstChildGrowOne, RaikoFlexAlignEnd
} from "@moeindal/base-raiko-panel-components";
import {useAuthState} from "../../context/AuthContext";
import {GroupsService} from "../../serverService/groups/GroupsService";
import {AccountTransactionsService} from "../../serverService/accountTransactions/AccountTransactionsService";
import {useNavigate} from "react-router-dom";
import {useDebounce} from "@uidotdev/usehooks";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {Skeleton} from "@mui/material";
import RaikoCardInfoTypeOne, {
    RaikoCardInfoTypeOneItemGenerator
} from "../../raikoComponents/raikoCardInfo/RaikoCardInfoTypeOne";
import RaikoShowPrice from "../../raikoComponents/raikoShowPrice/RaikoShowPrice";

export default function AccountUpdateTransactions() {

    const {fundID} = useAuthState()
    const groupService = new GroupsService()
    const accountService = new AccountTransactionsService()

    const navigate = useNavigate()

    const [groups, setGroups] = useState([]);

    const [selectedGroup, setSelectedGroup] = useState(-1)
    const [date, setDate] = useState("");

    const [accounts, setAccounts] = useState([]);
    const _accountsChange = useDebounce(accounts, 300)

    const [accountLoading, setAccountLoading] = useState(false);
    const [amount, setAmount] = useState(0);

    const filterGroup = useDebounce(selectedGroup, 300)
    const filterDate = useDebounce(date, 300)

    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        setAccounts([])
        getGroups()
    }, [fundID]);

    useEffect(_ => {
        if (filterGroup && filterDate && filterGroup >= 0 && filterDate.length === 10) {
            getAccounts()
        }
    }, [
        filterDate,
        filterGroup
    ])

    useEffect(() => {
        if (_accountsChange && _accountsChange.length > 0) {
            let _amount = 0
            _accountsChange.map(item => {
                if (item.amount)
                    _amount = _amount + parseInt(item.amount)
            })
            setAmount(_amount)
        } else
            setAmount(0)

    }, [_accountsChange])

    function getAccounts() {
        setAccountLoading(true)
        accountService.getPayableAccountsForUpdateDeposit(
            fundID,
            filterGroup,
            convertPersianDateToUniversalDate(date)
        ).then(response => {
            setAccounts(response)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setAccountLoading(false)
        })
    }

    function getGroups() {
        loading.show()
        groupService.getGroups(
            fundID,
            0,
            10000
        ).then(response => {
            setGroups([])
            response.data.map((item, index) => {
                setGroups(prev => [
                    ...prev,
                    raikoCustomSelectItemGenerator(item.id, item.name)
                ])
            })
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function changeAmount(id, amount) {
        const _accounts = accounts
        setAccounts([])
        _accounts.map((item, index) => {
            if (parseInt(id) === parseInt(item.id)) {
                setAccounts(prev => [
                    ...prev,
                    {
                        ...item,
                        amount
                    }
                ])
            } else {
                setAccounts(prev => [
                    ...prev,
                    item
                ])
            }
        })
    }

    function handleUpdateMonthlyDeposits() {
        loading.show()
        const _accounts = []
        accounts.map((item) => {
            _accounts.push(
                {
                    "amount": item.amount,
                    "id": item.id,
                    "depositedAt": item.depositedAt,
                    "enabled": item.amount !== "0"
                }
            )
        })


        accountService.updateMonthlyDepositTransactions(
            fundID,
            _accounts
        ).then(response => {
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    const [selectedTransactionInfo, setSelectedTransactionInfo] = useState(null);
    const [confirmDialogOpenState, setConfirmDialogOpenState] = useState(false);

    function openConfirmDialog() {
        setConfirmDialogOpenState(true)
    }

    function closeConfirmDialog() {
        setConfirmDialogOpenState(false)
        setSelectedTransactionInfo(null)
    }

    function handleDeleteTransaction() {
        loading.show()
        accountService.handleUpdateTransaction(
            fundID,
            selectedTransactionInfo.id,
            0,
            convertPersianDateToUniversalDate(date),
        ).then(response => {
            const _accounts = []
            accounts.map((item, index) => {
                if (parseInt(item.id) !== parseInt(selectedTransactionInfo.id)) {
                    _accounts.push(item)
                }
            })

            setAccounts(_accounts)

            closeConfirmDialog()
            showSuccessMessage("حذف تراکنش با موفقیت انجام شد")
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <>
            <RaikoConfirmDialog
                cancelAction={closeConfirmDialog} openConfirmDialog={confirmDialogOpenState}
                doAction={handleDeleteTransaction}
                pageTitle={`حذف تراکنش '${selectedTransactionInfo ? selectedTransactionInfo.ownerFirstName : ""} ${selectedTransactionInfo ? selectedTransactionInfo.ownerLastName : ""}'`}
                warningTitle={"آیا از حذف تراکنش اطمینان دارید؟"}
                warningDescription={"با اتمام حذف امکان بازگشت تراکنش وجود نخواهد داشت"}/>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb className={css`flex-grow: 1;
                          gap: .5rem;`} breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.AccountsTransactionsList.name,
                                RouteHelper.AccountsTransactionsList.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.AccountsNewTransaction.name,
                                ""
                            )
                        ]}/>

                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1);
                            }}/>
                    </RaikoFlexFirstChildGrowOne>

                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"ویرایش تراکنش گروهی پس انداز"}
                            subTitle={"بارگزاری حساب ها بر اساس گروه و تاریخ پرداخت"}
                        >

                            <RaikoGridTwoColumn>
                                <RaikoCustomSelect
                                    labelText={"گروه"}
                                    value={selectedGroup}
                                    setValue={setSelectedGroup}
                                    items={groups}/>

                                <RaikoDatePicker
                                    label={"تاریخ پرداخت"}
                                    date={date}
                                    setDate={setDate}/>

                            </RaikoGridTwoColumn>

                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>


                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"حساب ها"}
                                amount={accounts ? accounts.length : 0}
                            />
                            {
                                accountLoading ?
                                    <RaikoGridOneColumn>
                                        {[...Array(4)].map((item) => {
                                            return <Skeleton
                                                variant="rectangular"
                                                className={css`
                                                  height: 110px !important;
                                                  width: 100%;
                                                `}/>
                                        })}
                                    </RaikoGridOneColumn>
                                    :
                                    accounts && accounts.length > 0 ?
                                        <RaikoGridOneColumn className={css`position: relative;`}>
                                            <RaikoGridOneColumn>
                                                {
                                                    accounts.map((item, index) => {
                                                        return <RaikoCardInfoTypeOne
                                                            title={`${item.ownerFirstName} ${item.ownerLastName}`}
                                                            titleLabel={"مالک حساب"}
                                                            items={[
                                                                RaikoCardInfoTypeOneItemGenerator("موجودی (ریال)", convertCurrencyFormatPositiveNegative(item.currentBalance)),
                                                                RaikoCardInfoTypeOneItemGenerator("کد ملی", item.ownerNationalCode),
                                                                RaikoCardInfoTypeOneItemGenerator("شناسه حساب", item.depositAccountNumber),
                                                                RaikoCardInfoTypeOneItemGenerator("تاریخ واریز", date),
                                                                RaikoCardInfoTypeOneItemGenerator("تاریخ ثبت", convertUniversalDateTimeToPersianDateTime(item.createdAt)),
                                                                RaikoCardInfoTypeOneItemGenerator("پرداخت کننده", item.kind === "MANAGER_DEPOSIT" ? "مدیر سامانه" : "کاربر"),
                                                                RaikoCardInfoTypeOneItemGenerator("شناسه پرداخت کننده", item.depositedByManager ? item.depositedByManager : item.depositedByMember),
                                                                RaikoCardInfoTypeOneItemGenerator("تاخیر", item.hasBeenDelayed ? "دارد" : "ندارد"),
                                                            ]}
                                                            hasBottomChildren
                                                        >
                                                            <RaikoFlexAlignEnd>
                                                                <div>
                                                                    <RaikoButtonSecondary
                                                                        label={"حذف تراکنش"}
                                                                        onClick={_ => {
                                                                            setSelectedTransactionInfo(item)
                                                                            openConfirmDialog()
                                                                        }}
                                                                        className={css`height: 53px;`}
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <RaikoMoneyInputOutlined
                                                                        labelText={"مبلغ پس انداز (ریال)"}
                                                                        setValue={value => {
                                                                            changeAmount(item.id, value)
                                                                        }}
                                                                        value={item.amount}
                                                                    />
                                                                </div>
                                                            </RaikoFlexAlignEnd>
                                                        </RaikoCardInfoTypeOne>
                                                    })
                                                }
                                            </RaikoGridOneColumn>
                                            <div
                                                className={css`
                                                  display: flex;
                                                  flex-wrap: nowrap;
                                                  gap: 1rem;
                                                  align-items: center;
                                                `}
                                            >
                                            <span className={css`
                                              display: flex;
                                              flex-grow: 1;
                                              gap: .5rem;
                                            `}>
                                                <span>مجموع (ریال)</span>
                                                <RaikoShowPrice amount={amount}/>
                                            </span>
                                                <RaikoButtonPrimary
                                                    label={"بروزرسانی"}
                                                    onClick={handleUpdateMonthlyDeposits}
                                                />
                                            </div>
                                        </RaikoGridOneColumn>
                                        :
                                        <RaikoErrorSection
                                            title={"هیچ حسابی یافت نشد"}
                                            subTitle={"لطفا برای نمایش حساب های فیلتر های را تغییر دهید."}
                                        />
                            }
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}
